import React from 'react';

interface VideoPlayerProps extends Omit<React.VideoHTMLAttributes<HTMLVideoElement>, 'controlsList'> {
  controlsList?: string;
}

export const VideoPlayer = React.forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ controlsList, onLoadedMetadata, ...props }, ref) => {
    const defaultControlsList = 'nodownload noplaybackrate nofullscreen noremoteplayback';

    const handleLoadedMetadata = (e: React.SyntheticEvent<HTMLVideoElement>) => {
      const video = e.currentTarget;
      // WebM blobs from MediaRecorder often report Infinity duration.
      // Seeking to a large value forces the browser to compute the real duration,
      // which fixes the progress bar / seek indicator.
      if (!isFinite(video.duration)) {
        video.currentTime = 1e10;
        video.addEventListener('seeked', function handler() {
          video.removeEventListener('seeked', handler);
          video.currentTime = 0;
        });
      }
      onLoadedMetadata?.(e);
    };

    return (
      <video
        ref={ref}
        playsInline
        controlsList={controlsList ?? defaultControlsList}
        disablePictureInPicture
        disableRemotePlayback
        onLoadedMetadata={handleLoadedMetadata}
        {...props}
        style={{
          borderRadius: 'var(--mantine-radius-md)',
          ...props.style,
        }}
      />
    );
  }
);

VideoPlayer.displayName = 'VideoPlayer';
